/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type DealerDistinctions_seller = {|
  +isTopSeller: ?boolean;
  +isDistinguished: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DealerDistinctions_seller",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isTopSeller",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isDistinguished",
      "storageKey": null
    }
  ],
  "type": "Seller"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/DealerDistinctions/__generated__/DealerDistinctions_seller.graphql.js